/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Addopportunityowner_Success3Inputs */

const en_coinvestments_addopportunityowner_success3 = /** @type {(inputs: Coinvestments_Addopportunityowner_Success3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunity owner added successfully`)
};

/**
* | output |
* | --- |
* | "Opportunity owner added successfully" |
*
* @param {Coinvestments_Addopportunityowner_Success3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_addopportunityowner_success3 = /** @type {((inputs?: Coinvestments_Addopportunityowner_Success3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Addopportunityowner_Success3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_addopportunityowner_success3(inputs)
});
export { coinvestments_addopportunityowner_success3 as "coInvestments_addOpportunityOwner_success" }